module.exports = __webpack_public_path__ + "static/0061-18ca4011d4a30b9cfacb89e4bc000a36.png";